module.exports = __webpack_public_path__ + "img/illu2@2x.979f8eac.png";